import React from 'react';
import { getClassNames } from '../../helpers/classHelpers';
import { Status } from '../../helpers/statusHelpers';
import { withUIState } from '../../contexts/ui-state/withUIState';
import styles from './Chip.module.scss';

export enum Version {
    minified = 'minified',
}


export type ChipProps = {
    id?: string;
    label?: string | React.ReactNode;
    icon?: React.ReactElement;
    isActive?: boolean;
    className?: string;
    version?: Version;
    theme?: Status;
    minChipWidth?: 30;
    isDisabled?: boolean;
    isMinifiedStyle?: boolean;
    onClick?: () => void;
};

const Chip: React.FC<ChipProps> = ({ id, isDisabled, isMinifiedStyle, label, version, theme, icon, isActive, className, minChipWidth, onClick }) => {
    const onClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!onClick || isDisabled) return;

        e.preventDefault();
        e.stopPropagation();
        onClick();
    };

    return (
        <div id={id} onClick={onClickHandler} style={{ minWidth: minChipWidth }} className={getClassNames(['df-chip assist', theme && styles[`theme-${theme}`], version && styles[`version-${version}`], styles.chip, !!onClick && styles['clickable'], isActive && 'selected choice multi', isMinifiedStyle && styles['version-minified'], className])} role='button' tabIndex={0} aria-disabled={isDisabled} >
            {icon}
            {label && <span>{label}</span>}
        </div>
    );
};

export default withUIState(Chip);